import type { PublicSlotKey } from '@/apilib';
import type { AddPresetApi } from './addPresetApi';

export const AddPresetApiKey: PublicSlotKey<AddPresetApi> = {
  name: 'AddPresetApi',
  public: true,
};
